// extracted by mini-css-extract-plugin
export default {"error":"Error_error__9uczQ","show-hide":"Error_show-hide__dt3Eo","languageError":"Error_languageError__Jottu"};